import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ProviderOrderAddPage } from '../../../providers/orders/provider-order-add/provider-order-add';
import { ProductCreateWfoodcostStockPage } from '../../../products/product-create/product-create-without-foodcost/product-create-wfoodcost-stock/product-create-wfoodcost-stock';
import { ProductCreateWfoodcostAddStockPage } from '../../../products/product-create/product-create-without-foodcost/product-create-wfoodcost-add-stock/product-create-wfoodcost-add-stock';
import { StockElementPage } from '../../../analytics/reports/stock-element/stock-element';

/**
 * Generated class for the ArticleViewStockPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-article-view-stock',
    templateUrl: 'article-view-stock.html',
})
export class ArticleViewStockPage {
    @Input() article: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams) {
    }

    edit() {
        this.navCtrl.push(ProductCreateWfoodcostStockPage, {
            update_state: true,
            product_uid: this.article.UID,
            product_name: this.article.name,
            name_en: this.article.name_en,
            name_fr: this.article.name_fr,
            name_it: this.article.name_it,
            name_de: this.article.name_de,
            name_ca: this.article.name_ca,
            measurement: this.article.measurement,
            stock: this.article.stock,
            stock_alert: this.article.stock_alert,
            stock_max: this.article.stock_max,
            tags: this.article.tags,
            pvp: this.article.pvp,
            pvp2: this.article.pvp2,
            pvp3: this.article.pvp3,
            description_es: this.article.description_es,
            description_en: this.article.description_en,
            description_fr: this.article.description_fr,
            description_it: this.article.description_it,
            description_de: this.article.description_de,
            description_ca: this.article.description_ca,
            reference : this.article.reference,
            product: this.article
        });
    }

    add() {
        this.navCtrl.push(ProductCreateWfoodcostAddStockPage, {
            update_state: true,
            product_uid: this.article.UID,
            product_name: this.article.name,
            name_en: this.article.name_en,
            name_fr: this.article.name_fr,
            name_it: this.article.name_it,
            name_de: this.article.name_de,
            name_ca: this.article.name_ca,
            measurement: this.article.measurement,
            stock: this.article.stock,
            stock_alert: this.article.stock_alert,
            stock_max: this.article.stock_max,
            tags: this.article.tags,
            pvp: this.article.pvp,
            pvp2: this.article.pvp2,
            pvp3: this.article.pvp3,
            description_es: this.article.description_es,
            description_en: this.article.description_en,
            description_fr: this.article.description_fr,
            description_it: this.article.description_it,
            description_de: this.article.description_de,
            description_ca: this.article.description_ca,
            reference : this.article.reference,
            product: this.article
        })
    }

    openProviderOrderAdd(element) {
        this.navCtrl.push(ProviderOrderAddPage, {
            element: element,
            type: 'product'

        });
    }

    openElementStockAnalytics(product) {
        this.navCtrl.push(StockElementPage, {
            element: product
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/articles/articles-view/article-view-stock/article-view-stock.ts